import { clsx } from 'clsx';

export function Container({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className={clsx(className, 'px-6 lg:px-8')} data-testid="container">
      <div className="mx-auto max-w-2xl lg:max-w-7xl">{children}</div>
    </div>
  );
}
